import { render, staticRenderFns } from "./PointChargeModal.vue?vue&type=template&id=7f839f7a"
import script from "./PointChargeModal.vue?vue&type=script&lang=js"
export * from "./PointChargeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports